import { createSlice } from "@reduxjs/toolkit";

const initialDashboardState = {
    listLoading: false,
    dailyStatisticsLoading: false,
    monthlyTransactionsLoading: false,
    monthlyRevenueLoading: false,
    monthlyReceiptsLoading: false,
    actionsLoading: false,
    dailyStatistics: {},
    monthlyTransactions: [],
    monthlyRevenue: [],
    monthlyReceipts: [],
    error: null
};

export const callTypes = {
    list: "list",
    action: "action",
    dailyStatisticsLoading: "dailyStatisticsLoading",
    monthlyTransactionsLoading: "monthlyTransactionsLoading",
    monthlyRevenueLoading: "monthlyRevenueLoading",
    monthlyReceiptsLoading: "monthlyReceiptsLoading"
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: initialDashboardState,
    reducers: {
        catchError: (state, action) => {

            state.error = `${action.payload.error}`;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            }
            else if (action.payload.callType === callTypes.dailyStatisticsLoading) {
                state.dailyStatisticsLoading = false;
            }
            else if (action.payload.callType === callTypes.monthlyTransactionsLoading) {

                state.monthlyTransactionsLoading = false;

            }
            else if (action.payload.callType === callTypes.monthlyRevenueLoading) {

                state.monthlyRevenueLoading = false;
            }
            else if (action.payload.callType === callTypes.monthlyReceiptsLoading) {

                state.monthlyReceiptsLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            }
            else if (action.payload.callType === callTypes.dailyStatisticsLoading) {
                state.dailyStatisticsLoading = true;
            }
            else if (action.payload.callType === callTypes.monthlyTransactionsLoading) {

                state.monthlyTransactionsLoading = true;

            }
            else if (action.payload.callType === callTypes.monthlyRevenueLoading) {

                state.monthlyRevenueLoading = true;
            }
            else if (action.payload.callType === callTypes.monthlyReceiptsLoading) {

                state.monthlyReceiptsLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        /*
        dashboardDataFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.dailyStatistics = action.payload.dailyStats;
            state.monthlyTransactions = action.payload.monthlyTrans;
            state.monthlyRevenue = action.payload.monthlyRev;
            state.monthlyReceipts = action.payload.monthlyRec;
            state.error = null;
        },*/
        dailyStatsFetched: (state, action) => {
            //state.actionsLoading = false;
            //state.listLoading = false;
            state.dailyStatisticsLoading = false;
            state.dailyStatistics = action.payload.dailyStats;
            state.error = null;
        },
        monthlyTransFetched: (state, action) => {
            //state.actionsLoading = false;
            //state.listLoading = false;
            state.monthlyTransactionsLoading = false;
            state.monthlyTransactions = action.payload.monthlyTrans;
            state.error = null;
        },
        monthlyRevFetched: (state, action) => {
            //state.actionsLoading = false;
            //state.listLoading = false;
            state.monthlyRevenueLoading = false;
            state.monthlyRevenue = action.payload.monthlyRev;
            state.error = null;
        },
        monthlyRecFetched: (state, action) => {
            //state.actionsLoading = false;
            //state.listLoading = false;
            state.monthlyReceiptsLoading = false;
            state.monthlyReceipts = action.payload.monthlyRec;
            state.error = null;
        },
        resetDashboard: (state, action) => {
            state.listLoading =false;
            state.actionsLoading = false;
            state.dailyStatisticsLoading = false;
            state.monthlyReceiptsLoading = false;
            state.monthlyRevenueLoading = false;
            state.monthlyTransactionsLoading = false;
            
            state.dailyStatistics = {};
            state.monthlyTransactions = [];
            state.monthlyRevenue = [];
            state.monthlyReceipts = [];
            state.error = null;
        }        
    }
});

export const { actions } = dashboardSlice;
export const { reducer } = dashboardSlice;